import { LegacyCard, Spinner } from '@shopify/polaris';
import './LoadingSpinnerCard.css';

export const LoadingSpinnerCard = () => {
  return (
    <LegacyCard>
      <div className="loading-spinner-card">
        <Spinner size="large" />
      </div>
    </LegacyCard>
  );
};
